<template>
<div class="breadcrumb-box">
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }" class="active">
            首页
        </el-breadcrumb-item>
        <el-breadcrumb-item v-for="(item,index) in breadList" :key="index" :to="{ name: item.name }">{{item.meta.title}}
        </el-breadcrumb-item>
    </el-breadcrumb>
</div>
    
</template>

<script>
export default {
    data() {
        return {
            breadList: [] // 路由集合
        };
    },
    watch: {
        $route() {
            this.getBreadcrumb();
        }
    },
    methods: {
        isHome(route) {
            return route.name === "home";
        },
        getBreadcrumb() {
            let matched = this.$route.matched;
            //如果不是首页
            if (!this.isHome(matched[0])) {
                matched = [].concat(matched);
            }
            //跳转到首页不显示面包屑
            const data = matched.filter(item => item.path == '/home');
            if(data.length == 0) {
                this.breadList = matched;
            } else {
                this.breadList = [];
            }
        }
    },
    created() {
        this.getBreadcrumb();
    }
}
</script>

<style scoped lang="scss">
.active {
    ::v-deep {
        .el-icon-arrow-right:before {
            display: none;
        }
        .el-breadcrumb__inner {
            margin-right: -8px;
        }
    }
}
</style>